import React from "react";
import ReactDOMServer from "react-dom/server";

function TourVoucherTicketDetailStatic(booking) {
  if (!booking) return "";

  const selectedDescription = () => {
    if (
      !booking?.requestBody?.items?.at(0)?.productOptionCode ||
      !booking?.extraDetails?.productInfo?.productOptions
    ) {
      return booking?.extraDetails?.productInfo?.description;
    }
    return booking?.extraDetails?.productInfo?.productOptions?.find(
      (option) =>
        option?.productOptionCode ===
        booking?.requestBody?.items?.at(0)?.productOptionCode
    )?.description;
  };

  const meetingPoint = () => {
    const start = booking?.extraDetails?.productInfo?.logistics?.start?.map(
      (loc) => {
        const location = booking?.extraDetails?.productInfo?.locations?.find(
          (lc) => lc?.reference === loc?.location?.ref
        )?.name;
        return location;
      }
    );
    return start?.join(", ");
  };

  const meetingPointDescription = () => {
    const start = booking?.extraDetails?.productInfo?.logistics?.start?.map(
      (loc) => {
        return loc?.description;
      }
    );
    return start?.join(", ");
  };

  const endPoint = () => {
    const end = booking?.extraDetails?.productInfo?.logistics?.end?.map(
      (loc) => {
        const location = booking?.extraDetails?.productInfo?.locations?.find(
          (lc) => lc?.reference === loc?.location?.ref
        )?.name;
        return location;
      }
    );
    return end?.join(", ");
  };

  const endPointDescription = () => {
    const end = booking?.extraDetails?.productInfo?.logistics?.end?.map(
      (loc) => {
        return loc?.description;
      }
    );
    return end?.join(", ");
  };

  const staticContent = (
    <div className="w-full flex flex-col">
      <h4 className="text-7xl font-bold mb-2 mt-8">Know Before You Go</h4>
      <h5 className="mt-4 mb-6 font-semibold text-5xl">
        Information from your activity provider
      </h5>
      <div className="w-full mt-3 flex flex-col">
        <ul className="list-disc pl-6">
          {booking?.extraDetails?.productInfo?.additionalInfo?.map(
            (item, itemIndex) => (
              <li className="text-3xl mb-4 text-gray-800" key={itemIndex}>
                {item.description}
              </li>
            )
          )}
        </ul>
      </div>

      <h5 className="mt-10 text-5xl font-semibold">Tour option description</h5>
      <p className="text-3xl mt-4">{selectedDescription()}</p>

      <h5 className="mt-14 text-5xl font-semibold ">
        Inclusions and Exclusions
      </h5>
      <div className="w-full flex flex-col gap-2 mt-4">
        {booking?.extraDetails?.productInfo?.inclusions?.map(
          (disc, discIndex) => (
            <div
              className="w-full gap-2 flex items-start"
              key={`inc-${discIndex}`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.95801 15L3.20801 10.25L4.39551 9.06249L7.95801 12.625L15.6038 4.97916L16.7913 6.16666L7.95801 15Z"
                    fill="#000000"
                  />
                </svg>
              </div>
              <small className="text-3xl text-gray-800">
                {disc?.otherDescription || disc?.description}
              </small>
            </div>
          )
        )}
        {booking?.extraDetails?.productInfo?.exclusions?.map(
          (disc, discIndex) => (
            <div
              className="w-full gap-2 flex items-start"
              key={`exc-${discIndex}`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <svg
                  viewBox="0 0 24 24"
                  className="w-4 h-4 object-contain"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 21L12 12M12 12L3 3M12 12L21.0001 3M12 12L3 21.0001"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <small className="text-3xl text-gray-800">
                {disc?.otherDescription || disc?.description}
              </small>
            </div>
          )
        )}
        <h5 className="mt-10 text-5xl font-semibold mb-6">Meeting point</h5>
        <p className="text-3xl mb-4 text-gray-800">{meetingPoint()}</p>
        <p className="text-3xl mb-4 text-gray-800">
          {meetingPointDescription()}
        </p>
        <h5 className="mt-10 text-5xl font-semibold mb-6">End point</h5>
        <p className="text-3xl mb-4 text-gray-800">{endPoint()}</p>
        <p className="text-3xl mb-4 text-gray-800">{endPointDescription()}</p>
      </div>
    </div>
  );

  return ReactDOMServer.renderToStaticMarkup(staticContent);
}

export default TourVoucherTicketDetailStatic;
